<template>
  <div>
    <!-- <SectionHeader header="Company Details" image="uiw-font-person" :active="shouldShow ? true : false" /> -->
    <SectionHeader header="Business details" image="uiw-font-person" :active="shouldShow ? true : false" />
    <div class="bg-white q-pa-md q-mt-sm q-mb-md rounded" v-if="shouldShow">
      <EntityDetails
        :disableCollapse="disableEntityDetails"
        :openCollapse="openEntityDetails"
        @entityDetailsCompleted="entityDetailsCompleted"
      />
      <EntityCashFlow
        :disableCollapse="disableEntityCashFlow"
        :openCollapse="openEntityCashFlow"
        @entityCashFlowCompleted="entityCashFlowCompleted"
      />
      <FinanceDetails
        :disableCollapse="disableFinanceDetails"
        :openCollapse="openFinanceDetails"
        @financeDetailsCompleted="financeDetailsCompleted"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SectionHeader from '@/components/Atoms/SectionHeader';
import EntityDetails from './EntityDetails';
import EntityCashFlow from './EntityCashFlow';
import FinanceDetails from './FinanceDetails';
import MutateCreateOrUpdateProperty from '@/graphql/mutations/MutateCreateOrUpdateProperty';
import { GLOBAL_ERROR } from '@/components/GlobalError/GlobalError';

export default {
  name: 'CalculatorBusinessDetails',
  components: { SectionHeader, EntityDetails, EntityCashFlow, FinanceDetails },
  props: ['shouldShow'],
  computed: {
    ...mapState({
      scoreboard: (state) => state.vehicleApplication.vehicleApplication.scoreboard
    })
  },
  created() {
    if (this.scoreboard && this.scoreboard.businessDetails && this.scoreboard.businessDetails.entityDetails) {
      this.entityDetailsCompleted();
    } else return;

    if (this.scoreboard && this.scoreboard.businessDetails && this.scoreboard.businessDetails.annualRevenue) {
      this.entityCashFlowCompleted();
    } else return;

    if (
      this.scoreboard &&
      this.scoreboard.businessDetails &&
      this.scoreboard.businessDetails.financeDetails &&
      this.scoreboard.businessDetails.financeDetails.completed
    ) {
      this.financeDetailsCompleted();
    }
  },
  data: function () {
    return {
      disableEntityDetails: false,
      disableEntityCashFlow: true,
      disableFinanceDetails: true,
      openEntityDetails: true,
      openEntityCashFlow: false,
      openFinanceDetails: false
    };
  },
  methods: {
    entityDetailsCompleted: function (reInstate = false) {
      if (reInstate) {
        this.disableEntityCashFlow = true;
        this.openEntityDetails = true;
        this.openEntityCashFlow = false;
        setTimeout(() => {
          this.disableEntityCashFlow = false;
          this.openEntityDetails = false;
          this.openEntityCashFlow = true;
        });
      } else {
        this.disableEntityCashFlow = false;
        this.openEntityDetails = false;
        this.openEntityCashFlow = true;
      }
    },
    entityCashFlowCompleted: function (reInstate = false) {
      if (reInstate) {
        this.disableFinanceDetails = true;
        this.openEntityCashFlow = true;
        this.openFinanceDetails = false;
        setTimeout(() => {
          this.disableFinanceDetails = false;
          this.openEntityCashFlow = false;
          this.openFinanceDetails = true;
        });
      } else {
        this.disableFinanceDetails = false;
        this.openEntityCashFlow = false;
        this.openFinanceDetails = true;
      }
    },
    financeDetailsCompleted: function (shouldEmit) {
      this.openFinanceDetails = true;
      setTimeout(() => {
        this.openFinanceDetails = false;
      });
      if (shouldEmit) {
        setTimeout(() => {
          this.$emit('businessDetailsCreated');
        });
      }
    }
  }
};
</script>
